import { overlayMarkup } from '../markup'
import { stringToNode } from '../utils'

const initOverlayOnce = (): void => {
	const overlay = stringToNode(overlayMarkup)

	document.body.appendChild(overlay)
}

export default initOverlayOnce
